var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"page-tab",class:{ 'has-literature': _vm.itemCount > 0 },attrs:{"id":"saved-literature-tab","title":"Order Literature"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.itemCount))])}
var staticRenderFns = []

export { render, staticRenderFns }